import React from 'react';
import PropTypes from 'prop-types';
import { createBrowserHistory } from 'history';

import { ATTACHMENTS } from 'newJs/config';

const { VIEW_MODE, CLICK_ACTIONS } = ATTACHMENTS;
const {
    SAVE_TO_CONTACTS, SAVE_TO_FILES_ALL, SAVE_TO_FILES, SAVE_TO_FOTO
} = CLICK_ACTIONS;
const previewModes = [
    'calendarViewMode', 'imgViewMode', 'pdfViewMode', 'zipViewMode', 'playerMode'
];
const history = createBrowserHistory();
const screenOrientation = window.matchMedia('(orientation: portrait)');
const StateContext = React.createContext();
let unlistenHistory;

const historyBack = () => {
    history.back();
};

class StateProvider extends React.PureComponent {
    constructor(props) {
        super(props);
        // console.dir(props);
        const { value: { currentBreakpoint, imgIdsList = [] } } = props;
        this.state = {
            currentBreakpoint,
            imgIdsList,
            clickedItemData: {},
            currentViewMode: VIEW_MODE.INLINE,
            calendarViewMode: false,
            imgViewMode: false,
            pdfViewMode: false,
            playerMode: false,
            zipViewMode: false,
            device: {
                orientation: screenOrientation.matches
                    ? 'portrait'
                    : 'landscape'
            },
            savedItems: {
                [SAVE_TO_CONTACTS]: [],
                [SAVE_TO_FILES_ALL]: [],
                [SAVE_TO_FILES]: [],
                [SAVE_TO_FOTO]: []
            }
        };
    }

    static propTypes = {
        children: PropTypes.node.isRequired,
        value: PropTypes.object
    };

    isPreviewMode = () => {
        const activeModeIndex = previewModes.findIndex((mode) => this.state[mode] === true);
        return activeModeIndex > -1 ? previewModes[activeModeIndex] : false;
    };

    isSaved = (storeName, id) => {
        const savedStore = this.state.savedItems;
        if (Object.hasOwnProperty.call(savedStore, storeName)) {
            return savedStore[storeName].indexOf(id) === -1 ? false : true;
        }
        return -1;
    };

    setSaved = (storeName, data) => {
        if (this.isSaved(storeName, data)) {
            return;
        }

        this.setState((prevState) => ({
            savedItems: {
                ...prevState.savedItems,
                [storeName]: [
                    ...prevState.savedItems[storeName],
                    data
                ]
            }
        }));
    };

    setStateValue = (key, val, useHistory = false) => {
        if (Object.hasOwnProperty.call(this.state, key)) {
            this.setState({ [key]: val });

            if (useHistory) {
                const { pathname, search } = history.location;
                history.push({ pathname, search }/* , { test: val } */);
            }
        } else {
            console.error(`Attachments state does not have such key: ${key}!`);
        }
    };

    setScreenOrientation = (e) => {
        this.setState({ device: {
            orientation: e.matches ? 'portrait' : 'landscape'
        }});
    };

    componentDidMount () {
        const me = this;

        // Watch for screen rotation
        screenOrientation.addListener(this.setScreenOrientation);

        // Watch for history changes
        unlistenHistory = history.listen(({ /* location,  */action }) => {
            const previewMode = this.isPreviewMode();

            // On historu "go back"
            if (action === 'POP') {
                if (previewMode) {
                    me.setState({ [previewMode]: false });
                }
                else {
                    me.setState({ currentViewMode: VIEW_MODE.INLINE });
                }
            }
        });
    }

    componentWillUnmount() {
        screenOrientation.removeListener(this.setScreenOrientation);
        unlistenHistory();
    }

    render() {
        return (
            /* XXX: Use separated namespaces for state & methods */
            <StateContext.Provider value={{
                ...this.state,
                historyBack,
                isPreviewMode: this.isPreviewMode,
                isSaved: this.isSaved,
                setSaved: this.setSaved,
                setStateValue: this.setStateValue
            }}>
                {this.props.children}
            </StateContext.Provider>
        );
    }
}

export const useAttachsState = () => {
    const context = React.useContext(StateContext);

    if (context === undefined) {
        throw new Error('useAttachsState must be used within AttachsStateProvider');
    }

    return context;
};

export const AttachsStateContext = StateContext;
export default StateProvider;
